import React from "react";
import { Button } from "react-bootstrap";

const NextBtn = ({ handleStepChange, type, check }) => {
  return (
    <div className='resource-next-content'>
      <span onClick={() => handleStepChange(-1, -25)}>Previous step</span>
      <div className='resource-btn'>
        {!type ? (
          <Button
            className='cta-btn'
            // onClick={() => handleStepChange(1, 25)}
            type='submit'
          >
            Next Step
          </Button>
        ) : (
          <Button className='cta-btn'>Submit</Button>
        )}
      </div>
    </div>
  );
};

export default NextBtn;
